var LineItemType;

(function (LineItemType) {
  LineItemType["Automatic"] = "automatic";
  LineItemType["Manual"] = "manual";
  LineItemType["Credit"] = "credit";
  LineItemType["AdHocCharge"] = "adHocCharge";
})(LineItemType || (LineItemType = {}));

export {};